import React, { useRef, useState, useEffect } from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";

// import { HashLink } from "react-router-hash-link";

import "./App.scss";
import List from "./helplist/List";
import HomePlusHelp from "./MiscCompo/HomePlusHelp";
import Pdf404 from "./MiscCompo/Pdf404";
import UnderProcess from "./MiscCompo/UnderProcess";
import Pdf2 from "./MiscCompo/Pdf2";
import Liststringify from "./helplist/Liststringify";
import Icons from "./MiscCompo/Icons";
import PlusSearch from "./SEARCH/PlusSearch";
import Ooscompo from "./SEARCH/Ooscompo";
// import MEitemmaster from "./ContentCompo/MEitemmaster";
import WordFrame from "./ContentCompo/WordFrame";
import Transit from "./ContentCompo/Transit";
import Notifier from "./Notifier";

import Loader from "./MiscCompo/Loader";
import '@coreui/coreui/dist/css/coreui.min.css'
// import Bpannel from "./bpannel/Bpannel";

// import jrpdf from './pdf/jr.pdf';
// import nupdf from './pdf/nu.pdf';

function App() {
	const navigate = useNavigate();
	const [searchval, setSearchval] = useState("");
	const mainRef = useRef(null);

	const [callNotifier, setNotifier] = useState(false);
	const [notifyData, setNotifyData] = useState("alert toast");
	const handlenotifier = (obj) => {
		setNotifyData(obj);
		setNotifier(true);
	}
	
	useEffect(() => {
		// Set a timeout to hide the component after 5 seconds
		const timeoutId = setTimeout(() => {
			setNotifier(false);
		}, 8000);

		// Clear the timeout if the component is unmounted before the timeout expires
		return () => {
			clearTimeout(timeoutId);
		};
	}, [callNotifier]);

	const handleKeyDown = (event) => {
		event.stopPropagation();

        if (mainRef.current && mainRef.current.contains(event.target)) {
            // Handle key press logic here
            console.log('Arrow key pressed within the component!');
        }
		console.log('----> Arrow key pressed within the component!');
    };
	/* document.addEventListener("keydown", (e) => {
		if (e.key.toLowerCase() === "/") {
			document.getElementById("bsearch").focus();
			e.preventDefault();
			// alert('welcome jck');
		}
		if (e.key === "Escape") {
			document.getElementById("bsearch").blur();
			// console.log('alert');
		}
	}); */

	const sboxactive = () => {
		document.getElementById("bsearch").focus();
	};

	const lpdshowcommand = (oc) => {
		// const ele = document.querySelectorAll(".rpannel");
		const ele = document.querySelectorAll(".pannelflex");
		const hmbug = document.querySelectorAll(".menu-btn");
		ele.forEach((element) => {
			element.classList.toggle("show");
		});
		if (oc === "close") {
			hmbug[0]?.classList.remove("open");
			ele.forEach((element) => {
				element.classList.remove("show");
			});
		} else if (oc === "open") {
			hmbug[0]?.classList.add("open");
			ele.forEach((element) => {
				element.classList.add("show");
			});
		}
	};
	const lpdshow = () => {
		// const ele = document.querySelectorAll(".rpannel");
		const ele = document.querySelectorAll(".pannelflex");
		const hmbug = document.querySelectorAll(".menu-btn");
		ele.forEach((element) => {
			element.classList.toggle("show");
		});
		hmbug[0]?.classList.toggle("open");
	};

	const abs5 = () => {
		const ele = document.querySelectorAll(".mini-search");
		document.getElementById("search").focus();
		ele[0].classList.add("abs5");

		const ele1 = document.querySelectorAll(".pannelflex");
		const hmbug = document.querySelectorAll(".menu-btn");
		ele1.forEach((element) => {
			element.classList.remove("show");
		});
		hmbug[0].classList.remove("open");
	};

	const unabs5 = () => {
		const ele = document.querySelectorAll(".mini-search");
		ele[0].classList.remove("abs5");
		// navigate(-1);
	};

	const realsearch = (e) => {
		e.preventDefault();
		navigate("/pes", {
			state: {
				mysearch: searchval,
			},
		});
	};
	/* const word = (e) => {
		e.preventDefault();
		navigate("/pesw", {
			state: {
				mysearch: searchval,
			},
		});
	}; */

	return (
		<div onKeyDown={handleKeyDown}>
			<div className="mainframe" ref={mainRef}>
				<div className="menu">
					<div className="menu1" onClick={() => lpdshow()}>
						<Icons geticon="left-menu1" abs={unabs5} />
					</div>
					<Link className="menu2" to="/">
						<Icons geticon="ddlogo" />
					</Link>
					<p className="menu3">PLUS ERP HELP </p>
					{/* <HashLink to="/me/itemmaster#delele" scroll={(el) => el.scrollIntoView({ behavior: "smooth", block: "start" })}>
						Link to Hash Fragment
					</HashLink> */}
					{/* <Link to='json'>json</Link> */}

					<div className="menu4" onClick={() => sboxactive()}>
						<form onSubmit={(e) => realsearch(e)} role="search">
							{/* <label for="search">Search for stuff</label> */}
							<input type="search" onChange={(e) => setSearchval(e.currentTarget.value)} placeholder="Press[ / ] for Search..." required id="bsearch" name="bsearch" autoComplete="off" />
							<button type="submit">
								<Icons geticon="search" />
							</button>
							{/* <button onClick={(e) => word(e)}>
								<Icons geticon="pa-icon" />
							</button> */}
						</form>
					</div>

					<div className="mini-search">
						<form onSubmit={(e) => realsearch(e)} role="search">
							<Icons geticon="cross" passunabs5={unabs5} />
							<input id="search" onChange={(e) => setSearchval(e.currentTarget.value)} placeholder="Search..." autoComplete="off" autoFocus required name="search" />
							<button type="submit">
								<Icons geticon="search" />
							</button>
							{/* <Icons geticon="search" passclick={realsearch} /> */}
						</form>
					</div>

					<div className="menu5" onClick={(e) => abs5(e)}>
						<Icons geticon="search" />
					</div>
				</div>
				<div className="pannelflex">
					<div className="lpannel">
						<List togglef={lpdshow} flapcommand={lpdshowcommand} />
					</div>
					<div className="lpdblack" onClick={() => lpdshow()}></div>
					<div className="rpannel">
						{/* <div className="lpdynamic"> */}
						<Routes>
							<Route exact path="/" element={<HomePlusHelp />} />
							<Route exact path="/home" element={<HomePlusHelp />} />

							{/* <Route exact path="/me/itemmaster" element={<MEitemmaster />} /> */}
							<Route exact path="/fradoc" element={<WordFrame />} />
							{/* <Route exact path="/dynam" element={<Dynam />} /> */}
							<Route exact path="/transit/:iid" element={<Transit deployNotifier={handlenotifier}/>} />
							<Route exact path="/loader" element={<Loader />} />
							<Route exact path="/portal" element={<Notifier />} />
							<Route exact path="/oos/:ddmmyy" element={<Ooscompo />} />

							<Route exact path="/abc" element={<Pdf2 />} />
							<Route exact path="/json" element={<Liststringify />} />
							<Route exact path="/pes" element={<PlusSearch passclick={unabs5} />} />
							<Route exact path="/underprocesing......" element={<UnderProcess />} />
							<Route exact path="/*" element={<Pdf404 />} />
							{/* <Route exact path="main" element={<MainHome />} />
					<Route exact path="febprod" element={<Prod />} />
				</Route> */}
						</Routes>
						<div className="lpdblack" onClick={() => lpdshow()}></div>
						{/* <div className="lpannel-list">
							<List togglef={lpdshow} />
						</div> */}
						{/* <h1>JIGAR KAJIWALA</h1> */}
						{/* </div> */}

						{/* <div className="b-pannel">OK</div> */}
						{/* <Bpannel /> */}
					</div>
				</div>
			</div>
			{callNotifier && <Notifier boxobj={notifyData} />}
		</div>
	);
}

export default App;
